import { render, staticRenderFns } from "./projectManage.vue?vue&type=template&id=f5dd4c48&scoped=true"
import script from "./projectManage.vue?vue&type=script&lang=js"
export * from "./projectManage.vue?vue&type=script&lang=js"
import style0 from "./projectManage.vue?vue&type=style&index=0&id=f5dd4c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dd4c48",
  null
  
)

export default component.exports